export const Success = 0
export const BalanceIsLow = 1
export const NoAccess = 2
export const SignatureValidationFailed = 3
export const InternalError = 4
export const OfferNotSigned = 5
export const NotAllowedNow = 6
export const CreditLimitIsLow = 7
export const RoamingSignatureEmpty = 8
export const RoamingSignatureValidationFailed = 9
export const RoamingServiceProcessingError = 10
export const UnknownError = -1